module.exports = __webpack_public_path__ + "img/slika3.77d0bcf2.jpg";